import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=10fc2e9e&scoped=true"
import script from "./Samples.vue?vue&type=script&lang=js"
export * from "./Samples.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=10fc2e9e&prod&scoped=true&lang=css&external"
import style1 from "./Samples.vue?vue&type=style&index=1&id=10fc2e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc2e9e",
  null
  
)

export default component.exports